export default function MultipleChoiceGridIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="3" r="2" fill="#455468" />
      <circle cx="10" cy="3" r="2" fill="#455468" />
      <circle cx="17" cy="3" r="2" fill="#455468" />
      <circle cx="3" cy="10" r="2" fill="#455468" />
      <circle cx="10" cy="10" r="2" fill="#455468" />
      <circle cx="17" cy="10" r="2" fill="#455468" />
      <circle cx="3" cy="17" r="2" fill="#455468" />
      <circle cx="10" cy="17" r="2" fill="#455468" />
      <circle cx="17" cy="17" r="2" fill="#455468" />
    </svg>
  );
}
